const data = [
  {
    id: 1,
    image: "/quantessence.png",
    title: "Quantessence",
    description:
      "<em>Multilingual corporate website for a fintech company.</em><br>- Translated Figma concepts into responsive production-ready pages.<br>- Improved usability across desktop, tablet, and mobile devices.",
    link: "https://www.quantessence.com/",
    type: "site",
    stack: ["ReactJS, ", "TailwindCSS, ", "Azure"],
  },
  {
    id: 2,
    image: "/mel_portfolio.png",
    title: "Photography Portfolio",
    description:
      "<em>Modern portfolio website showcasing photography work.</em><br>- Crafted a responsive gallery experience with smooth animations.<br>- Enhanced performance through optimised image loading.",
    link: "https://melsgallery.vercel.app/",
    type: "site",
    stack: ["ReactJS, ", "TailwindCSS"],
  },
  {
    id: 3,
    image: "/guest_parking_manager.png",
    title: "Parking Manager",
    description:
      "<em>Parking reservation platform created from a product design challenge.</em><br>- Solved guest parking allocation for company events with uncertain attendance.<br>- Built intuitive booking and live availability flows.",
    link: "https://guest-parking-manager.netlify.app/",
    type: "site",
    stack: ["React, ", "TypeScript, ", "TailwindCSS "],
  },
  {
    id: 4,
    image: "/public_website.png",
    title: "Finlight",
    description:
      "<em>Financial web platform with integrated content management system.</em><br>- Implemented responsive landing pages and blog features.<br>- Turned Figma mockups into animated reusable components.",
    link: null,
    deprecated: true,
    stack: ["GatsbyJS, ", "NetlifyCMS, ", "TailwindCSS"],
  },
  {
    id: 5,
    image: "/finlight_app.png",
    title: "Finlight App",
    description:
      "<em>Financial web platform with scalable front-end architecture.</em><br>- Built reusable UI components with responsive layouts.<br>- Focused on clean user flows and maintainable code structure.",
    link: null,
    deprecated: true,
    stack: ["SolidJS, ", "TailwindCSS"],
  },
  {
    id: 6,
    image: "/ai_server.png",
    title: "AI Server",
    description:
      "<em>Training management platform for AI learners.</em><br>- Enabled users to launch model training jobs in Docker containers.<br>- Added queue handling and real-time progress monitoring.",
    link: "https://github.com/sebherrerabe/ai-server",
    type: "repo",
    stack: ["ReactJS, ", "CSS "],
  },
];

export default data;